/** The availability schedule every writer stores for a location open around the clock. */
export const AROUND_THE_CLOCK_SCHEDULE = "00:00 - 23:59";

const CLOCK_TIME = /^([01]\d|2[0-3]):[0-5]\d$/;

/** Whether `time` is an "HH:mm" clock time. The schedule is free text and older values aren't. */
export const isClockTime = (time: string | undefined): time is string =>
  !!time && CLOCK_TIME.test(time);

export const isAroundTheClock = (schedule: string | null | undefined): boolean =>
  schedule === AROUND_THE_CLOCK_SCHEDULE;

/** A location's "08:00 - 23:00" availability as its start and end time. */
export const splitAvailabilitySchedule = (
  schedule?: string | null,
): [start: string, end: string] => {
  const [start = "", end = ""] = schedule?.split("-").map((time) => time.trim()) ?? [];
  return [start, end];
};
